import React from "react";
import { Headphones } from "react-feather";
import { useClientRequestsBreakdown } from "./useClientRequestsBreakdown";
import KpiCard from "../components/KpiCard";

const ClientRequestsKpi = () => {
  const { canView, isFetching, openRequests, overdue } = useClientRequestsBreakdown();
  if (!canView) return null;

  return (
    <div className="col-6 col-xl-3">
      <KpiCard
        icon={<Headphones size={20} />}
        iconBg="#8E44AD"
        label="Client Requests"
        value={isFetching ? "..." : openRequests}
        caption={overdue > 0 ? `Overdue ↑ ${overdue}` : "None overdue"}
      />
    </div>
  );
};

export default ClientRequestsKpi;
